import * as React from 'react';

import { cn } from '@/lib/utils';

import NextImage, { NextImageProps } from '../image/index';

export const sizes = {
  m: 48,
  s: 36,
  xs: 24,
};

export type AvatarProps = {
  classNames?: {
    container?: string;
    image?: string;
  };
  size: keyof typeof sizes;
} & NextImageProps;

export default function Avatar({
  src,
  alt,
  size = 'm',
  classNames,
  ...props
}: AvatarProps) {
  return (
    <div
      className={cn(
        'relative flex overflow-auto',
        sizes[size],
        classNames?.container
      )}
    >
      <NextImage
        classNames={{ image: `rounded-full w-[${sizes[size]}px]` }}
        src={src}
        alt={alt || ''}
        data-tracker-component='avatar-image'
        {...props}
      />
    </div>
  );
}
